











































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import GrMoviePlayerModal from "../startPageNew/GrMoviePlayerModal.vue";
import TextWrapperReplacer from "../company/robotStepperModules/TextWrapperReplacer.vue";
import GrButton from "./GrButton.vue";
import MaxWidthSection from "./MaxWidthSection.vue";
import CTAButtonsCompany from "./CTAButtonsCompany.vue";

@Component({
  components: {
    GrButton,
    GrMoviePlayerModal,
    MaxWidthSection,
    TextWrapperReplacer,
    CTAButtonsCompany,
  },
})
export default class CompanyPageFirstPage extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly firstIsOnRight!: boolean;

  $refs!: Vue["$refs"] & {
    GrMoviePlayerModal: GrMoviePlayerModal;
  };

  playMovie() {
    this.$refs.GrMoviePlayerModal.open();
  }

  get swapColumns(): boolean {
    return this.firstIsOnRight && this.$vuetify.breakpoint.mdAndUp;
  }
}
